import { render, staticRenderFns } from "./TaskPage.vue?vue&type=template&id=6c0b824e&scoped=true"
import script from "./TaskPage.vue?vue&type=script&lang=js"
export * from "./TaskPage.vue?vue&type=script&lang=js"
import style0 from "./TaskPage.vue?vue&type=style&index=0&id=6c0b824e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0b824e",
  null
  
)

export default component.exports